import { useQuery } from '@tanstack/react-query';
import config from '../../../../../../config/config';
import Fetch from '../../../../../../util/core/Fetch';

const useServiceTypes = () => {
    return useQuery({
        queryKey: ['service-types'],
        queryFn: async () => {
            return await Fetch.post(
                config.endpoints.backend + 'governanceroom/esus/servicetypes',
                {}
            );
        },
        staleTime: Infinity
    });
};

export default useServiceTypes;
